import { render, staticRenderFns } from "./TapTop.vue?vue&type=template&id=568748ac&scoped=true&"
import script from "./TapTop.vue?vue&type=script&lang=js&"
export * from "./TapTop.vue?vue&type=script&lang=js&"
import style0 from "./TapTop.vue?vue&type=style&index=0&id=568748ac&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "568748ac",
  null
  
)

export default component.exports